import { StateServices } from '../../../../services/state.services'
import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'
import * as moment from 'moment'
import { imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { Subject, Subscription } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { SearchHelper } from '../../../../../helper/search.helper'
import { switchMap } from 'rxjs/internal/operators/switchMap'
import { APP_CONFIG, Config } from '@services/config.service'

@Component({
    selector: 'app-select-client',
    templateUrl: './select-client.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './select-client.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})

export class SelectClientComponent implements OnInit, OnDestroy {
    isActiveHotKey = false;
    listClinic: any;
    clinicClass;
    nameClinic;
    listDoctor: any;
    doctorClass;
    nameDoctor;
    acceleDent = '';
    defaultToogleText = 'Toggle switch to hide multiple items.';
    baseImageUrl = imageUrl;
    orthoPulse = '';
    activeVluesName = '';
    activeVluesLastVisit = '';
    activeVluesFirstVisit = '';
    activeVluesBirthdayVisit = '';
    activeVluesAccelerationDevice = '';
    activeVluesCase = '';
    activeVluesClinic = '';
    activeVluesClientNumber = '';
    activeVluesPhone = '';
    activeVluesDoctor = '';
    activeVluesPresentationName = '';
    activeValuesNameDetail = '';
    activeValuesLastVisitDetail = '';
    activeValuesFirstVisitDetail = '';
    activeValuesBirthdayDetail = '';
    activeValuesAccelerationDeviceDetail = '';
    activeValuesCaseDetail = '';
    activeValuesClinicDetail = '';
    activeValuesClientNumberDetail = '';
    activeValuesPhoneDetail = '';
    activeValuesDoctorDetail = '';
    activeValuesPresentationNameDetail = '';
    tableShowDataSearch = '';
    resourceUrl = 'resource';
    //Phuc edit 18/11/20
    // dataSearchResponse: any;
    dataSearchResponse: any[] = [];
    dataSearchResponseCount: any;
    valuesClinicID: any;
    valuesDoctorID: any;
    valuesAccelationDevice: any;
    valuesName: any;
    valuesCase: any;
    valuesClientNumber: any;
    valuesPhone: any;
    valuesPresentationName: any;
    valueslastDate: any;
    valuesFirstDate: any;
    valuesBirthdayDate: any;
    arrayKeySearchValuesBegin = [];
    arrayKeySearchValuesChangeForUser = {};
    resultNotification: any;
    dateModelLastVisit: any;
    optionsLastVisit: any = {format: 'YYYY.MM.DD ddd', showTodayButton: true, useCurrent: false};
    selecteLastVisit: any;
    dateModeFirstVisit: any;
    optionsFirstVisit: any = {format: 'YYYY.MM.DD ddd', showTodayButton: true, useCurrent: false};
    selecteFirstVisit: any;
    dateModeBirthday: any;
    optionsBirthday: any = {format: 'YYYY.MM.DD ddd', viewMode: 'years', useCurrent: false};
    selecteBirthday: any;
    localStoragePresentationMode: any;
    storagePresentationModeShow;
    en = {};
    showEN = true;
    listSearchReturnDetaillocal = {};
    showTableData: any;
    matrixImage: any[] = [];
    arrImage: any[] = [];
    presentationModeSmaillTr = '';
    // tmpDataSearchResponse: any[] = [];
    pageSize: any = 30;
    addPageSize: any = 30;

    listHeader: any[] = [];
    listFooter: any[] = [];

    clientProfileFormHeader: any[] = [];
    clientProfileFormFooter: any[] = [];

    listTagsHeader: any[] = [];
    listTagsFooter: any[] = [];

    arrayAlignerTabs: any[] = [];

    arrIdClickedTabs: any[] = [];
    jsonDataSearch: any = {};
    enableBehavior = 'false';

    arrSearchDefault: any[] = [
        {
            'propertyName': 'anyname',
            'title': 'Name',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-name',
        },
        {
            'propertyName': 'lastDate',
            'title': 'Last Visit',
            'schema': {
                'type': 'date',
                'uiOptions': {
                    'behavior': 'lastdaySingle',
                },
            },
            'en': 'app-client-search-lastDate',
        },
        {
            'propertyName': 'startDate',
            'title': 'First Visit',
            'schema': {
                'type': 'date',
                'uiOptions': {
                    'behavior': 'startdaySingle',
                },
            },
            'en': 'app-client-search-firstDate',
        },
        {
            'propertyName': 'birthday',
            'title': 'BirthDay',
            'schema': {
                'type': 'date',
                'uiOptions': {
                    'behavior': 'birthdaySingle',
                },
            },
            'en': 'app-client-search-birthday',
        },
        {
            'propertyName': 'accelationDevice',
            'title': 'Acceleration Device',
            'isListField': false,
            'schema': {
                'uiType': 'button',
                'type': 'string',
                'options': [
                    {
                        '_id': 'acceleDent',
                        'title': 'AcceleDent',
                    },
                    {
                        '_id': 'orthoPulse',
                        'title': 'OrthoPulse',
                    },
                    {
                        '_id': 'vpro+',
                        'title': 'Vpro+',
                    },
                    {
                        '_id': 'propel',
                        'title': 'Propel',
                    },
                    {
                        '_id': 'surgery',
                        'title': 'Surgery',
                    },
                    {
                        '_id': 'non',
                        'title': 'Non',
                    },
                ],
            },
            'en': 'app-client-search-accelationDevice',
        },
        {
            'propertyName': 'case',
            'title': 'Case',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-case',
        },
        {
            'propertyName': 'clinic',
            'title': 'Clinic',
            'isListField': false,
            'schema': {
                'uiType': 'button',
                'type': 'string',
                'options': [],
            },
            'en': 'app-client-search-clinic',
        },
        {
            'propertyName': 'clientNumber',
            'title': 'Client Number',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-clientNumber',
        },
        {
            'propertyName': 'anyphone',
            'title': 'Phone',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-anyphone',
        },
        {
            'propertyName': 'anyaddress',
            'title': 'Address',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-anyaddress',
        },
        {
            'propertyName': 'doctor',
            'title': 'Doctor',
            'isListField': false,
            'schema': {
                'uiType': 'button',
                'type': 'string',
                'options': [],
            },
            'en': 'app-client-search-doctor',
        },
        {
            'propertyName': 'presentationName',
            'title': 'Presentation Name',
            'schema': {
                'type': 'input',
            },
            'en': 'app-client-search-presentationName',
        },
        {
            'propertyName': 'lastSend',
            'title': 'Last Send',
            'schema': {
                'type': 'date',
                'uiOptions': {
                    'behavior': 'recentToday',
                },
            },
            'en': 'app-client-search-lastSend',
        },
        {
            'propertyName': 'lastPatientCommunicationAt',
            'title': 'Chat Send',
            'schema': {
                'type': 'date',
                'uiOptions': {
                    'behavior': 'recentToday',
                },
            },
            'en': 'app-client-search-chatSend',
        },
    ]

    private searchData: Subject<any> = new Subject();
    private strkeySearch: any;
    private searchSubcription: Subscription;
    private tokenReNew: any;
    //Phuc edit 18/11/20
    private offset: any = 0;
    private limit: any = 50;
    private initScroll: boolean = true;
    private currentCondition: any;
    styleImage: any[] = [];
    pageName: string = ''
    private togglePresentationModeSubscription: Subscription;
    
    constructor(
        private authData: AuthService,
        private router: Router,
        private restApi: RestServices,
        private _sharedService: SharedServices,
        public matrixServices: MatrixServices,
        private stateServices: StateServices,
        public cdRef: ChangeDetectorRef,
        @Inject(APP_CONFIG) config: Config,
    ) {
        this.pageName = this.stateServices.UseSearchPageList.SELECT_CLIENT.pageName
        this.activeValuesNameDetail = 'deleteValues'
        this.activeValuesLastVisitDetail = 'deleteValues'
        this.activeValuesFirstVisitDetail = 'deleteValues'
        this.activeValuesFirstVisitDetail = 'deleteValues'
        this.activeValuesBirthdayDetail = 'deleteValues'
        this.activeValuesAccelerationDeviceDetail = 'deleteValues'
        this.activeValuesCaseDetail = 'deleteValues'
        this.activeValuesClinicDetail = 'deleteValues'
        this.activeValuesClientNumberDetail = 'deleteValues'
        this.activeValuesPhoneDetail = 'deleteValues'
        this.activeValuesDoctorDetail = 'deleteValues'
        this.activeValuesPresentationNameDetail = 'deleteValues'
        this.tableShowDataSearch = 'hidden'
        this.getCachedSearchDataIfExist()

        let html = document.querySelector('html')
        html.classList.add('page-top')
        const emitDefaultArr: any = {}
        emitDefaultArr['default'] = this.arrSearchDefault
        this.stateServices.emitChangeDefaultArrSelect(emitDefaultArr)
        // if(this.arrayAlignerTabs) this.stateServices.emitChangeDefaultArrSelect(this.arrayAlignerTabs)
        // this.checkLocalStorage()
        this.localStoragePresentationMode = localStorage.getItem('presentationModeValue') === 'true' ? true : false
        /**
         * Search pipe (debounce the search time and distinct similar searching value)
         */
        this.searchSubcription = this.searchData.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(searchText => {
                //edit 18/11/20
                this.initScroll = false;
                this.currentCondition = searchText;
                this.offset = 0;
                this.dataSearchResponse= [];
                //end
                return this.search(searchText)
            }),
        ).subscribe(response => {
            // this.refreshToken();
            this.onSearchDone(response);
        });
        this.togglePresentationModeSubscription = this._sharedService.changeEmittedPresentationModeSearchData$.subscribe(
            success => {
                this.enableBehavior = this.stateServices.returnEnableBehavior()
                const emitIds = this.stateServices.getSearchTabIdsByPageNameUse(this.pageName)
                const isShowTable = this.stateServices.returnIsShowTableSelect()
                this.tableShowDataSearch = (isShowTable && isShowTable['activeTable']) ? isShowTable['activeTable'] : 'hidden'
                this.dataSearchResponse = []
                this.offset = 0
                if (success !== null) {
                    if (success[0] === 'arraySearchPresentationMode-selectData') {
                        this.localStoragePresentationMode = success[1]
                    }
                }

                if (this.localStoragePresentationMode === true) {
                    const arrayPresentationNameModeSearch = 'presentationNameMode'
                    const keySearchPresentationNameMode = { _$nin: null }
                    keySearchPresentationNameMode._$nin = [null, '']
                    this.storagePresentationModeShow = 'hidden'
                    this.presentationModeSmaillTr = 'smallTr'
                    if (!emitIds) {
                        this.getDatasearch(arrayPresentationNameModeSearch, keySearchPresentationNameMode, false, true)
                    } else {
                        this.searchData.next(emitIds)
                    }
                } else {
                    this.storagePresentationModeShow = 'active'
                    this.presentationModeSmaillTr = ''
                    if (!emitIds) {
                        this.addOrRemoveValuesSearch('presentationName', '', true, false)
                    } else {
                        this.searchData.next(emitIds)
                    }
                }
            })

        const listSearchReturnDetail = this._sharedService.arrayKeySearchValuesChangeForUser

        if (listSearchReturnDetail && listSearchReturnDetail.constructor === Object && Object.keys(listSearchReturnDetail).length !== 0 ) {

            this.tableShowDataSearch = 'active'
            this.resultNotification = this.defaultToogleText
            this.showTableData = true

            if (listSearchReturnDetail.hasOwnProperty('anyname')) {
                this.activeVluesName = 'tag-button-disabled'
                this.activeValuesNameDetail = 'addValuesDetail'
                if (listSearchReturnDetail.anyname != null) {
                    this.valuesName = listSearchReturnDetail.anyname._$regex
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('case')) {
                this.activeVluesCase = 'tag-button-disabled'
                this.activeValuesCaseDetail = 'addValuesDetail'
                if (listSearchReturnDetail.case != null) {
                    this.valuesCase = listSearchReturnDetail.case._$regex
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('clientNumber')) {
                this.activeVluesClientNumber = 'tag-button-disabled'
                this.activeValuesClientNumberDetail = 'addValuesDetail'
                if (listSearchReturnDetail.clientNumber != null) {
                    this.valuesClientNumber = listSearchReturnDetail.clientNumber
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('anyphone')) {
                this.activeVluesPhone = 'tag-button-disabled'
                this.activeValuesPhoneDetail = 'addValuesDetail'
                if (listSearchReturnDetail.anyphone != null) {
                    this.valuesPhone = listSearchReturnDetail.anyphone
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('presentationName')) {
                this.activeVluesPresentationName = 'tag-button-disabled'
                this.activeValuesPresentationNameDetail = 'addValuesDetail'
                if (listSearchReturnDetail.presentationName != null) {
                    this.valuesPresentationName = listSearchReturnDetail.presentationName._$regex
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('accelationDevice')) {
                this.activeVluesAccelerationDevice = 'tag-button-disabled'
                this.activeValuesAccelerationDeviceDetail = 'addValuesDetail'
                if (listSearchReturnDetail.accelationDevice == 'acceleDent') {
                    this.acceleDent = 'tag-button-disabled'
                } else if (listSearchReturnDetail.accelationDevice == 'orthoPulse') {
                    this.orthoPulse = 'tag-button-disabled'
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('clinic')) {
                this.activeVluesClinic = 'tag-button-disabled'
                this.activeValuesClinicDetail = 'addValuesDetail'
                if (listSearchReturnDetail.clinic != null) {
                    this.clinicClass = 'option_' + listSearchReturnDetail.clinic
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('doctor')) {
                this.activeVluesDoctor = 'tag-button-disabled'
                this.activeValuesDoctorDetail = 'addValuesDetail'
                if (listSearchReturnDetail.doctor != null) {
                    this.doctorClass = 'option_' + listSearchReturnDetail.doctor
                }
            }
            //
            if (listSearchReturnDetail.hasOwnProperty('lastDate')) {
                this.activeVluesLastVisit = 'tag-button-disabled'
                this.activeValuesLastVisitDetail = 'addValuesDetail'
                if (listSearchReturnDetail.lastDate != null) {
                    this.searchChangeLastDateKeySearch(moment(listSearchReturnDetail.lastDate).subtract(1, 'days'))
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('firstDate')) {
                this.activeVluesFirstVisit = 'tag-button-disabled'
                this.activeValuesFirstVisitDetail = 'addValuesDetail'
                if (listSearchReturnDetail.firstDate != null) {
                    this.dateModeFirstVisit = moment(listSearchReturnDetail.firstDate)
                }
            }

            if (listSearchReturnDetail.hasOwnProperty('birthday')) {
                this.activeVluesBirthdayVisit = 'tag-button-disabled'
                this.activeValuesBirthdayDetail = 'addValuesDetail'
                if (listSearchReturnDetail.birthday != null) {
                    this.searchChangeBirthdayKeySearch(moment(listSearchReturnDetail.birthday).subtract(1, 'days'))
                }
            }

        }
    }

    ngOnInit() {
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.stateServices.emitChangeViewAligner('searchData')
        this.mainClient()
        this.matrixServices.arrRotate = [0]
        this.matrixServices.arrStyleImage = [0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
        this.en = this.authData.showLang(true)
        this.refreshToken()
        // $('.ng-scrollbar-container').addClass('css-overflow');
    }

    refreshToken() {
        return this.authData.authToken().then(tokenReNew => {
            this.tokenReNew = tokenReNew
        })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        if (this.isActiveHotKey) {
            //Ctrl: 17; Command: 91; Enter: 13
            if ((event.ctrlKey || event.metaKey) && event.keyCode == 13) {
                this.showDataSearch(true)
            }
        }
    }

    ngOnDestroy(): void {
        const html = document.querySelector('html')
        html.classList.remove('page-top')
        this.jsonDataSearch = {}
        this.arrayAlignerTabs = []
        if(this.searchSubcription)
            this.searchSubcription.unsubscribe()
        if (this.togglePresentationModeSubscription) {
            this.togglePresentationModeSubscription.unsubscribe()
        }
    }

    checkLocalStorage() {
        const emitIds = this.stateServices.getSearchTabIdsByPageNameUse(this.pageName)
        const isShowTable = this.stateServices.returnIsShowTableSelect()
        this.tableShowDataSearch = (isShowTable && isShowTable['activeTable']) ? isShowTable['activeTable'] : 'hidden'
        this.localStoragePresentationMode = localStorage.getItem('presentationModeValue')
        if (this.localStoragePresentationMode === 'true') {
            this.presentationModeSmaillTr = 'smallTr'
            const arrayPresentationNameModeSearch = 'presentationNameMode'
            const keySearchPresentationNameMode = { _$nin: null }
            this.storagePresentationModeShow = 'hidden'
            keySearchPresentationNameMode._$nin = [null, '']
            this.localStoragePresentationMode = true
            if (!emitIds) {
                this.getDatasearch(arrayPresentationNameModeSearch, keySearchPresentationNameMode, false, true)
            }
        } else {
            this.presentationModeSmaillTr = ''
            this.localStoragePresentationMode = false
            if (!emitIds) {
                this.getDatasearch(null, null, true, false)
            }
        }
    }

    changLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    onChangeStructure(newObj, structureTime) {

    }

    prevDate(key, nameTime) {
        if (nameTime == 'lastvisit') {
            if (this.selecteLastVisit == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModelLastVisit = moment(this.dateModelLastVisit).subtract(day, 'days').format('YYYY.MM.DD ddd')
            }
        } else if (nameTime == 'firstvisit') {
            if (this.selecteFirstVisit == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModeFirstVisit = moment(this.dateModeFirstVisit).subtract(day, 'days').format('YYYY.MM.DD ddd')
            }
        } else if (nameTime == 'birthday') {
            if (this.selecteBirthday == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModeBirthday = moment(this.dateModeBirthday).subtract(day, 'days').format('YYYY.MM.DD ddd')
            }
        }
    }

    nextDate(key, nameTime) {
        if (nameTime == 'lastvisit') {
            if (this.selecteLastVisit == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModelLastVisit = moment(this.dateModelLastVisit).add(day, 'days').format('YYYY.MM.DD ddd')
            }
        } else if (nameTime == 'firstvisit') {
            if (this.selecteFirstVisit == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModeFirstVisit = moment(this.dateModeFirstVisit).add(day, 'days').format('YYYY.MM.DD ddd')
            }
        } else if (nameTime == 'birthday') {
            if (this.selecteBirthday == 'days') {
                let day = 7
                if (key == 1) {
                    day = 1
                }
                this.dateModeBirthday = moment(this.dateModeBirthday).add(day, 'days').format('YYYY.MM.DD ddd')
            }
        }
    }

    mainClient() {
    }

    selectClientDetail(id) {
        this.router.navigateByUrl('/app/main/client/edit/' + id + '/home')
        this._sharedService.getIdParam(id)
        this._sharedService.getlisIfSearch(this.arrayKeySearchValuesChangeForUser)
    }

    creatValuesDoctor(data) {
        const arayDoctor = data
        if (data.length > 0) {
            arayDoctor.forEach(function(doctorItem) {
                if (doctorItem.familyName) {
                    doctorItem.fullName = doctorItem.familyName + ' ' + doctorItem.firstName
                } else {
                    doctorItem.fullName = doctorItem.firstName
                }
            })
            return arayDoctor
        }
    }

    //select clinic
    toggleClinnicItem(id, event, values) {
        let arrayClinicKeySearch = 'clinic'
        if (this.clinicClass == id) {
            this.clinicClass = ''
            this.valuesClinicID = null
            this.getDatasearch(arrayClinicKeySearch, null, false, false)
        } else {
            this.clinicClass = id
            this.nameClinic = event.target.innerText
            this.valuesClinicID = values
            this.getDatasearch(arrayClinicKeySearch, this.valuesClinicID, false, false)
        }
    }

    //select doctor
    toggleDoctorItem(id, event, values) {
        let arrayDoctorKeySearch = 'doctor'
        if (this.doctorClass == id) {
            this.doctorClass = ''
            this.valuesDoctorID = null
            this.getDatasearch(arrayDoctorKeySearch, null, false, false)
        } else {
            this.doctorClass = id
            this.nameDoctor = event.target.innerText
            this.valuesDoctorID = values
            this.getDatasearch(arrayDoctorKeySearch, this.valuesDoctorID, false, false)
        }
    }

    //select Acceleration Device
    selectDevice(valuesDevice) {
        let arrayAccelationDeviceKeySearch = 'accelationDevice'
        if (valuesDevice == 'acceledent') {
            if (this.acceleDent == 'tag-button-disabled') {
                this.acceleDent = ''
                this.getDatasearch(arrayAccelationDeviceKeySearch, null, false, false)
            } else {
                this.acceleDent = 'tag-button-disabled'
                this.valuesAccelationDevice = 'acceleDent'
                this.getDatasearch(arrayAccelationDeviceKeySearch, this.valuesAccelationDevice, false, false)
            }
            this.orthoPulse = ''
        } else if (valuesDevice == 'orthopulse') {
            if (this.orthoPulse == 'tag-button-disabled') {
                this.orthoPulse = ''
                this.getDatasearch(arrayAccelationDeviceKeySearch, null, false, false)
            } else {
                this.orthoPulse = 'tag-button-disabled'
                this.valuesAccelationDevice = 'orthoPulse'
                this.getDatasearch(arrayAccelationDeviceKeySearch, this.valuesAccelationDevice, false, false)
            }
            this.acceleDent = ''
        }
    }

    //select Name
    searchChangeNameKeySearch(keySearch) {
        var keySearchNameChange = this.valuesName
        let arrayAnynameKeySearch = 'anyname'
        var keySearchName = keySearchNameChange
        this.getDatasearch(arrayAnynameKeySearch, keySearchName, false, false)
    }

    //select Case
    searchChangeNameKeyCase(keySearch) {
        var keySearchCaseChange = this.valuesCase
        let arrayCaseKeySearch = 'case'
        var keySearchCase = keySearchCaseChange
        this.getDatasearch(arrayCaseKeySearch, keySearchCase, false, false)
    }

    //select clientNumber
    searchChangeClientNumberKey(keySearch) {
        var keySearchClientNumberChange = this.valuesClientNumber
        let arrayClientNumberSearch = 'clientNumber'
        var keySearchClientNumber = keySearchClientNumberChange
        this.getDatasearch(arrayClientNumberSearch, keySearchClientNumber, false, false)
    }

    //select Phone
    searchChangePhoneKey(keySearch) {
        var keySearchAnyPhoneChange = this.valuesPhone
        let arrayClientNumberSearch = 'anyphone'
        var keySearchAnyPhone = keySearchAnyPhoneChange
        this.getDatasearch(arrayClientNumberSearch, keySearchAnyPhone, false, false)
    }

    //select Presentation Nam
    searchChangePresentationNameKey(keySearch) {
        var keySearchPresentationNameChange = this.valuesPresentationName
        let arrayCaseKeySearch = 'presentationName'
        var keySearchPresentationName = keySearchPresentationNameChange
        this.getDatasearch(arrayCaseKeySearch, keySearchPresentationName, false, false)
    }

    //select last date
    searchChangeLastDateKeySearch(event: any) {
        if (event != null) {
            let dateModelLastVisitEvent = event
            var keySearchLastDateChange = this.valueslastDate = moment(dateModelLastVisitEvent['_d']).add(1, 'days').utc().startOf('day').valueOf()
            let arrayLastDateKeySearch = 'lastDate'
            var keySearchLastDate = keySearchLastDateChange
            this.getDatasearch(arrayLastDateKeySearch, keySearchLastDate, false, false)
        }
    }

    //select first date
    searchChangeFirstDateKeySearch(event: any) {
        if (event != null) {
            event.add(5, 'minutes')
            let dateModelFirstVisitEvent = event
            var keySearchFirstVisitChange = this.valuesFirstDate = moment(dateModelFirstVisitEvent['_d']).utc().startOf('day').valueOf()
            let arrayFirstVisitKeySearch = 'firstDate'
            var keySearchFirstDate = keySearchFirstVisitChange
            this.getDatasearch(arrayFirstVisitKeySearch, keySearchFirstDate, false, false)
        }
    }

    //select birth date
    searchChangeBirthdayKeySearch(event: any) {
        if (event != null) {
            let dateModelBirthdayEvent = event
            var keySearchBirthdayChange = this.valueslastDate = moment(dateModelBirthdayEvent['_d']).add(1, 'days').utc().startOf('day').valueOf()
            let arrayBirthdayKeySearch = 'birthday'
            var keySearchBirthday = keySearchBirthdayChange
            this.getDatasearch(arrayBirthdayKeySearch, keySearchBirthday, false, false)
        }
    }

    addOrRemoveValuesSearch(arrayKeySearch, values = null, removeValuesSearch = true, addValuesSearch = true) {
        if (arrayKeySearch == 'anyname') {
            let arrayAnynameKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchName = null
                if (values != null) {
                    keySearchName._$regex = values
                }
                this.getDatasearch(arrayAnynameKeySearch, keySearchName, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesName = null
                this.getDatasearch(arrayAnynameKeySearch, keySearchName, true, false)
            }
        }


        if (arrayKeySearch == 'case') {
            let arrayCaseKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchCase = null
                if (values != null) {
                    keySearchCase._$regex = values
                }
                this.getDatasearch(arrayCaseKeySearch, keySearchCase, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesCase = null
                this.getDatasearch(arrayCaseKeySearch, keySearchCase, true, false)
            }
        }

        if (arrayKeySearch == 'presentationName') {
            let arrayPresentationNameKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchPresentationName = null
                if (values != null) {
                    keySearchPresentationName._$regex = values
                }
                this.getDatasearch(arrayPresentationNameKeySearch, keySearchPresentationName, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesPresentationName = null
                this.getDatasearch(arrayPresentationNameKeySearch, keySearchPresentationName, true, false)
            }
        }

        if (arrayKeySearch == 'clientNumber') {
            let arrayClientNumberKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchClientNumber = null
                if (values != null) {
                    keySearchClientNumber = values
                }
                this.getDatasearch(arrayClientNumberKeySearch, keySearchClientNumber, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesClientNumber = null
                this.getDatasearch(arrayClientNumberKeySearch, keySearchClientNumber, true, false)
            }
        }

        if (arrayKeySearch == 'anyphone') {
            let arrayAnyPhoneKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchAnyPhone = null
                if (values != null) {
                    keySearchAnyPhone = values
                }
                this.getDatasearch(arrayAnyPhoneKeySearch, keySearchAnyPhone, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesPhone = null
                this.getDatasearch(arrayAnyPhoneKeySearch, keySearchAnyPhone, true, false)
            }
        }


        if (arrayKeySearch == 'accelationDevice') {
            let arrayAccelerationDeviceKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchAccelerationDevice = null
                if (values != null) {
                    keySearchAccelerationDevice = values
                }
                this.getDatasearch(arrayAccelerationDeviceKeySearch, keySearchAccelerationDevice, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesAccelationDevice = null
                this.getDatasearch(arrayAccelerationDeviceKeySearch, keySearchAccelerationDevice, true, false)
            }
        }


        if (arrayKeySearch == 'clinic') {
            let arrayClinicKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchClinic = null
                if (values != null) {
                    keySearchClinic = values
                }
                this.getDatasearch(arrayClinicKeySearch, keySearchClinic, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesClinicID = null
                this.getDatasearch(arrayClinicKeySearch, keySearchClinic, true, false)
            }
        }


        if (arrayKeySearch == 'doctor') {
            let arrayDoctorKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchDoctor = null
                if (values != null) {
                    keySearchDoctor = values
                }
                this.getDatasearch(arrayDoctorKeySearch, keySearchDoctor, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.valuesDoctorID = null
                this.getDatasearch(arrayDoctorKeySearch, keySearchDoctor, true, false)
            }
        }

        if (arrayKeySearch == 'lastDate') {
            let arrayLastDateKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchLastDate = null
                if (values != null) {
                    keySearchLastDate = values
                }
                this.getDatasearch(arrayLastDateKeySearch, keySearchLastDate, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.getDatasearch(arrayLastDateKeySearch, keySearchLastDate, true, false)
            }
        }

        if (arrayKeySearch == 'firstDate') {
            let arrayFirstDateKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchFirstDate = null
                if (values != null) {
                    keySearchFirstDate = values
                }
                this.getDatasearch(arrayFirstDateKeySearch, keySearchFirstDate, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.getDatasearch(arrayFirstDateKeySearch, keySearchFirstDate, true, false)
            }
        }

        if (arrayKeySearch == 'birthday') {
            let arrayBirthdayKeySearch = arrayKeySearch
            if (addValuesSearch == true && removeValuesSearch == false) {
                var keySearchBirthday = null
                if (values != null) {
                    keySearchBirthday = values
                }
                this.getDatasearch(arrayBirthdayKeySearch, keySearchBirthday, false, true)
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                this.getDatasearch(arrayBirthdayKeySearch, keySearchBirthday, true, false)
            }
        }


    }

    addClasSelectValue(valuesname) {
        if (valuesname == 'name') {
            if (this.activeVluesName == 'tag-button-disabled') {
                this.activeVluesName = ''
                this.activeValuesNameDetail = 'deleteValues'
                this.addOrRemoveValuesSearch('anyname', '', true, false)
            } else {
                this.activeVluesName = 'tag-button-disabled'
                this.activeValuesNameDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('anyname', this.valuesName, false, true)
            }
        } else if (valuesname == 'lastDate') {
            if (this.activeVluesLastVisit == 'tag-button-disabled') {
                this.activeVluesLastVisit = ''
                this.activeValuesLastVisitDetail = 'deleteValues'
                this.selecteLastVisit = ''
                this.valueslastDate = ''
                this.addOrRemoveValuesSearch('lastDate', '', true, false)
            } else {
                this.activeVluesLastVisit = 'tag-button-disabled'
                this.activeValuesLastVisitDetail = 'addValuesDetail'
                this.dateModelLastVisit = moment().format('YYYY MM DD ddd')
                this.selecteLastVisit = 'days'
                this.searchChangeLastDateKeySearch(this.dateModelLastVisit)
            }
        } else if (valuesname == 'firstDate') {
            if (this.activeVluesFirstVisit == 'tag-button-disabled') {
                this.activeVluesFirstVisit = ''
                this.activeValuesFirstVisitDetail = 'deleteValues'
                this.selecteFirstVisit = ''
                this.valuesFirstDate = ''
                this.addOrRemoveValuesSearch('firstDate', '', true, false)
            } else {
                this.activeVluesFirstVisit = 'tag-button-disabled'
                this.activeValuesFirstVisitDetail = 'addValuesDetail'
                this.dateModeFirstVisit = moment()
                this.selecteFirstVisit = 'days'
                this.searchChangeFirstDateKeySearch(this.dateModeFirstVisit)
            }
        } else if (valuesname == 'birthday') {
            if (this.activeVluesBirthdayVisit == 'tag-button-disabled') {
                this.activeVluesBirthdayVisit = ''
                this.activeValuesBirthdayDetail = 'deleteValues'
                this.selecteBirthday = ''
                this.valuesBirthdayDate = ''
                this.addOrRemoveValuesSearch('birthday', '', true, false)
            } else {
                this.activeVluesBirthdayVisit = 'tag-button-disabled'
                this.activeValuesBirthdayDetail = 'addValuesDetail'
                this.dateModeBirthday = moment()
                this.selecteBirthday = 'days'
                this.searchChangeBirthdayKeySearch(this.dateModeBirthday)
            }
        } else if (valuesname == 'accelationDevice') {
            if (this.activeVluesAccelerationDevice == 'tag-button-disabled') {
                this.activeVluesAccelerationDevice = ''
                this.activeValuesAccelerationDeviceDetail = 'deleteValues'
                this.orthoPulse = ''
                this.acceleDent = ''
                this.addOrRemoveValuesSearch('accelationDevice', '', true, false)
            } else {
                this.activeVluesAccelerationDevice = 'tag-button-disabled'
                this.activeValuesAccelerationDeviceDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('accelationDevice', this.valuesAccelationDevice, false, true)
            }
        } else if (valuesname == 'case') {
            if (this.activeVluesCase == 'tag-button-disabled') {
                this.activeVluesCase = ''
                this.activeValuesCaseDetail = 'deleteValues'
                this.addOrRemoveValuesSearch('case', '', true, false)
            } else {
                this.activeVluesCase = 'tag-button-disabled'
                this.activeValuesCaseDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('case', this.valuesCase, false, true)
            }
        } else if (valuesname == 'clinic') {
            if (this.activeVluesClinic == 'tag-button-disabled') {
                this.activeVluesClinic = ''
                this.activeValuesClinicDetail = 'deleteValues'
                this.clinicClass = ''
                this.addOrRemoveValuesSearch('clinic', '', true, false)
            } else {
                this.activeVluesClinic = 'tag-button-disabled'
                this.activeValuesClinicDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('clinic', this.valuesClinicID, false, true)
            }
        } else if (valuesname == 'clientNumber') {
            if (this.activeVluesClientNumber == 'tag-button-disabled') {
                this.activeVluesClientNumber = ''
                this.activeValuesClientNumberDetail = 'deleteValues'
                this.addOrRemoveValuesSearch('clientNumber', '', true, false)
            } else {
                this.activeVluesClientNumber = 'tag-button-disabled'
                this.activeValuesClientNumberDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('clientNumber', this.valuesClientNumber, false, true)
            }
        } else if (valuesname == 'anyphone') {
            if (this.activeVluesPhone == 'tag-button-disabled') {
                this.activeVluesPhone = ''
                this.activeValuesPhoneDetail = 'deleteValues'
                this.addOrRemoveValuesSearch('anyphone', '', true, false)
            } else {
                this.activeVluesPhone = 'tag-button-disabled'
                this.activeValuesPhoneDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('anyphone', this.valuesPhone, false, true)
            }
        } else if (valuesname == 'doctor') {
            if (this.activeVluesDoctor == 'tag-button-disabled') {
                this.activeVluesDoctor = ''
                this.activeValuesDoctorDetail = 'deleteValues'
                this.doctorClass = ''
                this.addOrRemoveValuesSearch('doctor', '', true, false)
            } else {
                this.activeVluesDoctor = 'tag-button-disabled'
                this.activeValuesDoctorDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('doctor', this.valuesDoctorID, false, true)
            }
        } else if (valuesname == 'presentationName') {
            if (this.activeVluesPresentationName == 'tag-button-disabled') {
                this.activeVluesPresentationName = ''
                this.activeValuesPresentationNameDetail = 'deleteValues'
                this.addOrRemoveValuesSearch('presentationName', '', true, false)
            } else {
                this.activeVluesPresentationName = 'tag-button-disabled'
                this.activeValuesPresentationNameDetail = 'addValuesDetail'
                this.addOrRemoveValuesSearch('presentationName', this.valuesPresentationName, false, true)
            }
        } else if (valuesname == '') {

        }
    }

    deleteClasSelectValue(valuesnameDelete) {
        if (valuesnameDelete) {
            this.addClasSelectValue(valuesnameDelete)
        } else if (valuesnameDelete == '') {

        }
    }

    showDataSearch(showOrHiddenDatat) {
        if (showOrHiddenDatat == true) {
            if (this.tableShowDataSearch == 'active') {
                this.tableShowDataSearch = 'hidden'
                this.resultNotification = 'Result contains ' + this.dataSearchResponseCount + ' items.Limit search condition, or toggle switch to show all items.'
            } else {
                this.tableShowDataSearch = 'active'
                this.resultNotification = this.defaultToogleText
            }
            const emitIdsSearch: any = {}
            emitIdsSearch['activeTable'] = this.tableShowDataSearch
            this.stateServices.emitChangeIsShowTableSelect(emitIdsSearch)
        }
    }

    getDatasearch(arrayKeySearch = null, keySearchName = null, removeValuesSearch = true, addValuesSearch = true) {
        // console.log("arrayKeySearch: " + arrayKeySearch + " keySearchName: " + keySearchName + " removeValuesSearch: " + removeValuesSearch + " addValuesSearch: " + addValuesSearch);
        if (!this.arrayKeySearchValuesChangeForUser) {
            this.arrayKeySearchValuesBegin = [];
        }
        this.listSearchReturnDetaillocal = this._sharedService.arrayKeySearchValuesChangeForUser;
        if (typeof this.listSearchReturnDetaillocal !== 'undefined') {
            this.arrayKeySearchValuesChangeForUser = this.listSearchReturnDetaillocal;
        }
        var arrCheck = ['anyname', 'case', 'presentationName'];
        if (arrCheck.indexOf(arrayKeySearch) != -1) {
            var key = arrayKeySearch;
            var keySearch = keySearchName;
            if (addValuesSearch == true && removeValuesSearch == false) {
                this.arrayKeySearchValuesChangeForUser[key] = keySearch;
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                delete this.arrayKeySearchValuesChangeForUser[key];
            } else if (addValuesSearch == false && removeValuesSearch == false) {
                delete this.arrayKeySearchValuesChangeForUser[key];
                if (key == 'presentationName') {
                    if (localStorage.getItem('presentationModeValue') === 'true') {
                        this.arrayKeySearchValuesChangeForUser[key] = {'_$regex': keySearch, '_$nin': [null, '']};
                    } else {
                        this.arrayKeySearchValuesChangeForUser[key] = {'_$regex': keySearch};
                    }
                } else {
                    this.arrayKeySearchValuesChangeForUser[key] = {'_$regex': keySearch};
                }
            }
        } else {
            var arrCheckbox = ['accelationDevice', 'clientNumber', 'anyphone', 'clinic', 'doctor', 'lastDate', 'firstDate', 'birthday'];
            if (arrCheckbox.indexOf(arrayKeySearch) != -1) {
                var key = arrayKeySearch;
                var keySearch = keySearchName;
                if (addValuesSearch == true && removeValuesSearch == false) {
                    this.arrayKeySearchValuesChangeForUser[key] = keySearch;
                } else if (addValuesSearch == false && removeValuesSearch == true) {
                    delete this.arrayKeySearchValuesChangeForUser[key];
                } else if (addValuesSearch == false && removeValuesSearch == false) {
                    delete this.arrayKeySearchValuesChangeForUser[key];
                    this.arrayKeySearchValuesChangeForUser[key] = keySearch;
                }
            }
        }

        if (arrayKeySearch == 'presentationNameMode') {
            var key = arrayKeySearch;
            var keySearch = keySearchName;
            if (addValuesSearch == true && removeValuesSearch == false) {
                this.arrayKeySearchValuesChangeForUser['presentationName'] = keySearch;
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                delete this.arrayKeySearchValuesChangeForUser['presentationName'];
            } else if (addValuesSearch == false && removeValuesSearch == false) {
                delete this.arrayKeySearchValuesChangeForUser['presentationName'];
                this.arrayKeySearchValuesChangeForUser['presentationName'] = keySearch;
            }
        }

        const arrayKeySearchForeach = this.arrayKeySearchValuesChangeForUser;
        const result = JSON.stringify(arrayKeySearchForeach);
        const searches = {};
        searches[result] = true;
        const resourceDataAccessLog = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true
                    }
                },
                client: {
                    searches
                },
                setting: {
                    map: {
                        common: true
                    },
                    paths: {
                        '{}': true
                    }
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true
                    }
                }
            },
            page: {
                offset: this.offset,
                limit: this.limit
            }
        };

        // console.log("condition first search: " + JSON.stringify(resourceDataAccessLog));
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    if (success) {
                        const user = success['user'];
                        this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id']);
                        const emitSakura = {};
                        emitSakura['enableBehavior'] = this.enableBehavior;
                        this.stateServices.emitChangeEnableBehavior(emitSakura);
                        const arraySettingAll: any[] = success['response']['setting']['paths']['{}'];
                        const arraySettingOption = arraySettingAll.find(el => {
                            return el['_id'] == 'option';
                        });
                        if (arraySettingOption) {
                            this.clientProfileFormHeader = arraySettingOption['clientProfileFormHeader'] ? arraySettingOption['clientProfileFormHeader']['properties'] : [];
                            this.clientProfileFormFooter = arraySettingOption['clientProfileFormFooter'] ? arraySettingOption['clientProfileFormFooter']['properties'] : [];
                        } else {
                            this.clientProfileFormHeader = [];
                            this.clientProfileFormFooter = [];
                        }
                        this.listClinic = success['response']['clinic']['paths']['{}'];
                        this.listDoctor = this.creatValuesDoctor(success['response']['staff']['paths']['{}']);
                        const optionsClinic: any[] = [];
                        const optionsDoctor: any[] = [];
                        this.listClinic.forEach(el => {
                            el['title'] = el['name'];
                            optionsClinic.push(el);
                        });
                        const findClinic = this.arrSearchDefault.findIndex(el => {
                            return el['propertyName'] == 'clinic';
                        });
                        if (findClinic != -1) {
                            const clinic = this.arrSearchDefault[findClinic];
                            clinic['schema']['options'] = optionsClinic;
                            this.arrSearchDefault[findClinic] = clinic;
                        }
                        this.listDoctor.forEach(el => {
                            el['title'] = el['fullName'];
                            optionsDoctor.push(el);
                        });
                        const findDoctor = this.arrSearchDefault.findIndex(el => {
                            return el['propertyName'] == 'doctor';
                        });
                        if (findDoctor != -1) {
                            const doctor = this.arrSearchDefault[findDoctor];
                            doctor['schema']['options'] = optionsDoctor;
                            this.arrSearchDefault[findDoctor] = doctor;
                        }

                        if (this.enableBehavior == 'true') {
                            this.listHeader = this.clientProfileFormHeader.filter(el => {
                                return el['isListField'] == true;
                            });
                            this.listFooter = this.clientProfileFormFooter.filter(el => {
                                return el['isListField'] == true;
                            });

                            this.listTagsHeader = this.clientProfileFormHeader.filter(el => {
                                return el['isCondition'] == true;
                            });
                            this.listTagsFooter = this.clientProfileFormFooter.filter(el => {
                                return el['isCondition'] == true;
                            });
                            this.arrayAlignerTabs = this.arrSearchDefault.concat(this.listTagsHeader, this.listTagsFooter);
                        } else {
                            this.listHeader = [];
                            this.listFooter = [];
                            this.listTagsHeader = [];
                            this.listTagsFooter = [];
                            this.arrayAlignerTabs = jQuery.extend(true, [], this.arrSearchDefault);
                        }
                        let tmpDataSearchResponse = success['response']['client']['searches'][result];
                        this.dataSearchResponse = this.dataSearchResponse.concat(tmpDataSearchResponse);
                        this.dataSearchResponseCount = success['total'];
                        this.sumarySearchText();

                        $('.ng-scrollbar').removeClass('-vertical');
                    }
                }
            );
        });
    }


    getDatasearchOld(arrayKeySearch = null, keySearchName = null, removeValuesSearch = true, addValuesSearch = true) {
        if (!this.arrayKeySearchValuesChangeForUser) {
            this.arrayKeySearchValuesBegin = []
        }
        this.listSearchReturnDetaillocal = this._sharedService.arrayKeySearchValuesChangeForUser
        if (typeof this.listSearchReturnDetaillocal !== 'undefined') {
            this.arrayKeySearchValuesChangeForUser = this.listSearchReturnDetaillocal
        }
        var arrCheck = ['anyname', 'case', 'presentationName']
        if (arrCheck.indexOf(arrayKeySearch) != -1) {
            var key = arrayKeySearch
            var keySearch = keySearchName
            if (addValuesSearch == true && removeValuesSearch == false) {
                this.arrayKeySearchValuesChangeForUser[key] = keySearch
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                delete this.arrayKeySearchValuesChangeForUser[key]
            } else if (addValuesSearch == false && removeValuesSearch == false) {
                delete this.arrayKeySearchValuesChangeForUser[key]
                if (key == 'presentationName') {
                    if (localStorage.getItem('presentationModeValue') === 'true') {
                        this.arrayKeySearchValuesChangeForUser[key] = { '_$regex': keySearch, '_$nin': [null, ''] }
                    } else {
                        this.arrayKeySearchValuesChangeForUser[key] = { '_$regex': keySearch }
                    }
                } else {
                    this.arrayKeySearchValuesChangeForUser[key] = { '_$regex': keySearch }
                }
            }
        } else {
            var arrCheckbox = ['accelationDevice', 'clientNumber', 'anyphone', 'clinic', 'doctor', 'lastDate', 'firstDate', 'birthday']
            if (arrCheckbox.indexOf(arrayKeySearch) != -1) {
                var key = arrayKeySearch
                var keySearch = keySearchName
                if (addValuesSearch == true && removeValuesSearch == false) {
                    this.arrayKeySearchValuesChangeForUser[key] = keySearch
                } else if (addValuesSearch == false && removeValuesSearch == true) {
                    delete this.arrayKeySearchValuesChangeForUser[key]
                } else if (addValuesSearch == false && removeValuesSearch == false) {
                    delete this.arrayKeySearchValuesChangeForUser[key]
                    this.arrayKeySearchValuesChangeForUser[key] = keySearch
                }
            }
        }

        if (arrayKeySearch == 'presentationNameMode') {
            var key = arrayKeySearch
            var keySearch = keySearchName
            if (addValuesSearch == true && removeValuesSearch == false) {
                this.arrayKeySearchValuesChangeForUser['presentationName'] = keySearch
            } else if (addValuesSearch == false && removeValuesSearch == true) {
                delete this.arrayKeySearchValuesChangeForUser['presentationName']
            } else if (addValuesSearch == false && removeValuesSearch == false) {
                delete this.arrayKeySearchValuesChangeForUser['presentationName']
                this.arrayKeySearchValuesChangeForUser['presentationName'] = keySearch
            }
        }

        const arrayKeySearchForeach = this.arrayKeySearchValuesChangeForUser
        const result = JSON.stringify(arrayKeySearchForeach)
        const searches = {}
        searches[result] = true
        const resourceDataAccessLog = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    searches,
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        // this.arrayAlignerTabs = jQuery.extend(true, {}, this.arrSearchDefault);

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    if (success) {
                        const user = success['user']
                        this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                        const emitSakura = {}
                        emitSakura['enableBehavior'] = this.enableBehavior
                        this.stateServices.emitChangeEnableBehavior(emitSakura)
                        const arraySettingAll: any[] = success['response']['setting']['paths']['{}']
                        const arraySettingOption = arraySettingAll.find(el => {
                            return el['_id'] == 'option'
                        })
                        if (arraySettingOption) {
                            this.clientProfileFormHeader = arraySettingOption['clientProfileFormHeader'] ? arraySettingOption['clientProfileFormHeader']['properties'] : []
                            this.clientProfileFormFooter = arraySettingOption['clientProfileFormFooter'] ? arraySettingOption['clientProfileFormFooter']['properties'] : []
                        } else {
                            this.clientProfileFormHeader = []
                            this.clientProfileFormFooter = []
                        }
                        this.listClinic = success['response']['clinic']['paths']['{}']
                        this.listDoctor = this.creatValuesDoctor(success['response']['staff']['paths']['{}'])
                        const optionsClinic: any[] = []
                        const optionsDoctor: any[] = []
                        this.listClinic.forEach(el => {
                            el['title'] = el['name']
                            optionsClinic.push(el)
                        })
                        const findClinic = this.arrSearchDefault.findIndex(el => {
                            return el['propertyName'] == 'clinic'
                        })
                        if (findClinic != -1) {
                            const clinic = this.arrSearchDefault[findClinic]
                            clinic['schema']['options'] = optionsClinic
                            this.arrSearchDefault[findClinic] = clinic
                        }
                        this.listDoctor.forEach(el => {
                            el['title'] = el['fullName']
                            optionsDoctor.push(el)
                        })
                        const findDoctor = this.arrSearchDefault.findIndex(el => {
                            return el['propertyName'] == 'doctor'
                        })
                        if (findDoctor != -1) {
                            const doctor = this.arrSearchDefault[findDoctor]
                            doctor['schema']['options'] = optionsDoctor
                            this.arrSearchDefault[findDoctor] = doctor
                        }

                        if (this.enableBehavior == 'true') {
                            this.listHeader = this.clientProfileFormHeader.filter(el => {
                                return el['isListField'] == true && el['type'] != 'separator'
                            })
                            this.listFooter = this.clientProfileFormFooter.filter(el => {
                                return el['isListField'] == true && el['type'] != 'separator'
                            })

                            this.listTagsHeader = this.clientProfileFormHeader.filter(el => {
                                return el['isCondition'] == true && el['type'] != 'separator'
                            })
                            this.listTagsFooter = this.clientProfileFormFooter.filter(el => {
                                return el['isCondition'] == true && el['type'] != 'separator'
                            })
                            this.arrayAlignerTabs = this.arrSearchDefault.concat(this.listTagsHeader, this.listTagsFooter)
                        } else {
                            this.listHeader = []
                            this.listFooter = []
                            this.listTagsHeader = []
                            this.listTagsFooter = []
                            this.arrayAlignerTabs = jQuery.extend(true, [], this.arrSearchDefault)
                        }

                        // this.tmpDataSearchResponse = success['response']['client']['searches'][result]
                        // this.dataSearchResponse = this.tmpDataSearchResponse.slice(0, this.pageSize)
                        // // this.dataSearchResponse = success['response']['client']['searches'][result];
                        // this.dataSearchResponseCount = this.tmpDataSearchResponse.length

                        this.sumarySearchText()

                        $('.ng-scrollbar').removeClass('-vertical')
                    }
                },
            )
        })
    }

    showOptionsString(stringInput: string) {
        let returnString = ''
        if (stringInput && stringInput != '') {
            if (stringInput.length > 100) {
                returnString = stringInput.substring(0, 100) + '...'
            } else {
                returnString = stringInput
            }
        }
        return returnString
    }

    getWayAppear(propertyName, item, tab) {
        const returnArray = 'array'
        const returnSelectString = 'stringSelect'
        const returnJson = 'json'
        const returnString = 'string'
        const returnDate = 'date'
        if (typeof item == 'object') {
            if (Array.isArray(item)) {
                return returnArray
            }
            return returnJson
        } else if (typeof item == 'number') {
            return returnDate
        } else {
            let findItem
            if (tab == 'header') {
                findItem = this.clientProfileFormHeader.find(el => {
                    return el['propertyName'] == propertyName
                })
            } else {
                findItem = this.clientProfileFormFooter.find(el => {
                    return el['propertyName'] == propertyName
                })
            }
            if (findItem) {
                if (findItem['schema'] && findItem['schema']['uiType'] == 'button') {
                    return returnSelectString
                }
            }
        }
        return returnString
    }

    showOptionSelect(optionId, propertyName, tab) {
        if (tab == 'header') {
            const findItem = this.clientProfileFormHeader.find(el => {
                return el['propertyName'] == propertyName
            })
            if (findItem) {
                const listOptions = findItem['schema']['options']
                const result = listOptions.find(el => {
                    return el['_id'] == optionId
                })
                if (result) {
                    return result['title']
                }
                return ''
            }
            return ''
        } else {
            const findItem = this.clientProfileFormFooter.find(el => {
                return el['propertyName'] == propertyName
            })
            if (findItem) {
                const listOptions = findItem['schema']['options']
                const result = listOptions.find(el => {
                    return el['_id'] == optionId
                })
                if (result) {
                    return result['title']
                }
                return ''
            }
            return ''
        }
    }

    showDate(datesString) {
        const initDate: Date = new Date(datesString)
        const year = initDate.getFullYear()
        const month = ((initDate.getMonth() + 1) < 10) ? ('0' + (initDate.getMonth() + 1)) : (initDate.getMonth() + 1)
        const date = (initDate.getDate() < 10) ? ('0' + initDate.getDate()) : initDate.getDate()
        return year + '.' + month + '.' + date
    }

    searchScroll(dataSearch: any) {
        let arrIdClickedTabsTemp = [];
        this.arrIdClickedTabs = dataSearch['arrIdClickedTabs'];
        this.jsonDataSearch = dataSearch['jsonDataSearch'].hasOwnProperty('lastSend') ? JSON.parse(JSON.stringify(dataSearch['jsonDataSearch'])) : dataSearch['jsonDataSearch'];
        this.jsonDataSearch = dataSearch['jsonDataSearch'].hasOwnProperty('lastPatientCommunicationAt') ? JSON.parse(JSON.stringify(dataSearch['jsonDataSearch'])) : dataSearch['jsonDataSearch'];
        if (this.arrayAlignerTabs.length > 0) {
            const emitIdsSearch: any = {};
            emitIdsSearch['arrIdClickedTabs'] = this.arrIdClickedTabs;
            emitIdsSearch['arrayAlignerTabs'] = this.arrayAlignerTabs;
            emitIdsSearch['jsonDataSearch'] = this.jsonDataSearch;
            this.stateServices.emitChangeSearchTabIdsByPageNameUse(this.pageName, emitIdsSearch);
        }
        if (this.jsonDataSearch.hasOwnProperty('lastSend')) {
            this.jsonDataSearch.lastSend = this.searchLastSend(this.jsonDataSearch.lastSend);
        }
        if (this.jsonDataSearch.hasOwnProperty('lastPatientCommunicationAt')) {
            this.jsonDataSearch.lastPatientCommunicationAt = this.searchChatSend(this.jsonDataSearch.lastPatientCommunicationAt)
        }
        //edit 17/12/20
        this.arrIdClickedTabs.forEach((searchTab, index) => {
            let searchData = this.jsonDataSearch[searchTab];
            if(searchData){
                arrIdClickedTabsTemp.push(searchTab);
            }
        });
        //end
        // this.strkeySearch = SearchHelper.buildQuery(this.arrIdClickedTabs, this.jsonDataSearch, this.arrayAlignerTabs);
        this.strkeySearch = SearchHelper.buildQuery(arrIdClickedTabsTemp, this.jsonDataSearch, this.arrayAlignerTabs, localStorage.getItem('presentationModeValue') === 'true');
        // console.log(this.strkeySearch);
        const searches = {};
        searches[this.strkeySearch] = true;

        const resourceDataAccessLog = this.restApi.makeResourceObject({
            status: {
                client: {
                    searches
                },
            },
            page: {
                offset: this.offset,
                limit: this.limit
            }
        });
        // console.log("search condition: " + JSON.stringify(resourceDataAccessLog));
        return resourceDataAccessLog;
    }

    search(dataSearch: any) {
        let arrIdClickedTabsTemp = [];
        this.arrIdClickedTabs = dataSearch['arrIdClickedTabs'];
        this.jsonDataSearch = dataSearch['jsonDataSearch'].hasOwnProperty('lastSend') ? JSON.parse(JSON.stringify(dataSearch['jsonDataSearch'])) : dataSearch['jsonDataSearch'];
        this.jsonDataSearch = dataSearch['jsonDataSearch'].hasOwnProperty('lastPatientCommunicationAt') ? JSON.parse(JSON.stringify(dataSearch['jsonDataSearch'])) : dataSearch['jsonDataSearch'];
        if (this.arrayAlignerTabs.length > 0) {
            const emitIdsSearch: any = {}
            emitIdsSearch['arrIdClickedTabs'] = this.arrIdClickedTabs
            emitIdsSearch['arrayAlignerTabs'] = this.arrayAlignerTabs
            emitIdsSearch['jsonDataSearch'] = this.jsonDataSearch
            this.stateServices.emitChangeSearchTabIdsByPageNameUse(this.pageName, emitIdsSearch)
        }
        if (this.jsonDataSearch.hasOwnProperty('lastSend')) {
            this.jsonDataSearch.lastSend = this.searchLastSend(this.jsonDataSearch.lastSend)
        }
        if (this.jsonDataSearch.hasOwnProperty('lastPatientCommunicationAt')) {
            this.jsonDataSearch.lastPatientCommunicationAt = this.searchChatSend(this.jsonDataSearch.lastPatientCommunicationAt)
        }
        //edit 17/12/20
        this.arrIdClickedTabs.forEach((searchTab, index) => {
            let searchData = this.jsonDataSearch[searchTab];
            if(searchData){
                arrIdClickedTabsTemp.push(searchTab);
            }
        });
        //end
        // this.strkeySearch = SearchHelper.buildQuery(this.arrIdClickedTabs, this.jsonDataSearch, this.arrayAlignerTabs);
        this.strkeySearch = SearchHelper.buildQuery(arrIdClickedTabsTemp, this.jsonDataSearch, this.arrayAlignerTabs, localStorage.getItem('presentationModeValue') === 'true');
        // console.log(this.strkeySearch);
        const searches = {};
        searches[this.strkeySearch] = true;

        const resourceDataAccessLog = this.restApi.makeResourceObject({
            status: {
                client: {
                    searches,
                },
            },
            page: {
                offset: this.offset,
                limit: this.limit
            }
        });
        // console.log("search condition: " + JSON.stringify(resourceDataAccessLog));
        return this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, this.tokenReNew);
    }

    searchOld(dataSearch: any) {
        this.arrIdClickedTabs = dataSearch['arrIdClickedTabs'];
        this.jsonDataSearch = dataSearch['jsonDataSearch'].hasOwnProperty('lastSend') ? JSON.parse(JSON.stringify(dataSearch['jsonDataSearch'])) : dataSearch['jsonDataSearch'];
        if (this.arrayAlignerTabs.length > 0) {
            const emitIdsSearch: any = {};
            emitIdsSearch['arrIdClickedTabs'] = this.arrIdClickedTabs;
            emitIdsSearch['arrayAlignerTabs'] = this.arrayAlignerTabs;
            emitIdsSearch['jsonDataSearch'] = this.jsonDataSearch;
            this.stateServices.emitChangeIdsSearchTabs(emitIdsSearch);
        }
        if (this.jsonDataSearch.hasOwnProperty('lastSend')) {
            this.jsonDataSearch.lastSend = this.searchLastSend(this.jsonDataSearch.lastSend);
        }
        this.strkeySearch = SearchHelper.buildQuery(this.arrIdClickedTabs, this.jsonDataSearch, this.arrayAlignerTabs);
        const searches = {};
        searches[this.strkeySearch] = true;

        const resourceDataAccessLog = this.restApi.makeResourceObject({
            status: {
                client: {
                    searches
                },
            }
        });
        console.log(resourceDataAccessLog)
        return this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, this.tokenReNew)
    }

    onSearchDone(success) {
        if (success) {
            const arraySettingAll: any[] = success['response']['setting']['paths']['{}']
            const arraySettingOption = arraySettingAll.find(el => {
                return el['_id'] == 'option'
            })
            if (arraySettingOption) {
                this.clientProfileFormHeader = arraySettingOption['clientProfileFormHeader'] ? arraySettingOption['clientProfileFormHeader']['properties'] : []
                this.clientProfileFormFooter = arraySettingOption['clientProfileFormFooter'] ? arraySettingOption['clientProfileFormFooter']['properties'] : []
            } else {
                this.clientProfileFormHeader = []
                this.clientProfileFormFooter = []
            }

            this.listClinic = success['response']['clinic']['paths']['{}']
            this.listDoctor = this.creatValuesDoctor(success['response']['staff']['paths']['{}'])
            const optionsClinic: any[] = []
            const optionsDoctor: any[] = []
            this.listClinic.forEach(el => {
                el['title'] = el['name']
                optionsClinic.push(el)
            })
            const findClinic = this.arrSearchDefault.findIndex(el => {
                return el['propertyName'] == 'clinic'
            })
            if (findClinic != -1) {
                const clinic = this.arrSearchDefault[findClinic]
                clinic['schema']['options'] = optionsClinic
                this.arrSearchDefault[findClinic] = clinic
            }
            this.listDoctor.forEach(el => {
                el['title'] = el['fullName']
                optionsDoctor.push(el)
            })
            const findDoctor = this.arrSearchDefault.findIndex(el => {
                return el['propertyName'] == 'doctor'
            })
            if (findDoctor != -1) {
                const doctor = this.arrSearchDefault[findDoctor]
                doctor['schema']['options'] = optionsDoctor
                this.arrSearchDefault[findDoctor] = doctor
            }
            let tmpDataSearchResponse = success['response']['client'] && success['response']['client']['searches'] && success['response']['client']['searches'][this.strkeySearch] ? success['response']['client']['searches'][this.strkeySearch] : [];
            // this.tmpDataSearchResponse = success['response']['client'] && success['response']['client']['searches'] && success['response']['client']['searches'][this.strkeySearch] ? success['response']['client']['searches'][this.strkeySearch] : [];
            this.dataSearchResponse = this.dataSearchResponse.concat(tmpDataSearchResponse);
            this.dataSearchResponseCount = success['total'];
            this.sumarySearchText();
            $('.ng-scrollbar').removeClass('-vertical');
        }
    }

    onSearchDoneOld(success) {
        if (success) {
            const arraySettingAll: any[] = success['response']['setting']['paths']['{}'];
            const arraySettingOption = arraySettingAll.find(el => {
                return el['_id'] == 'option';
            });
            if (arraySettingOption) {
                this.clientProfileFormHeader = arraySettingOption['clientProfileFormHeader'] ? arraySettingOption['clientProfileFormHeader']['properties'] : [];
                this.clientProfileFormFooter = arraySettingOption['clientProfileFormFooter'] ? arraySettingOption['clientProfileFormFooter']['properties'] : [];
            } else {
                this.clientProfileFormHeader = [];
                this.clientProfileFormFooter = [];
            }

            this.listClinic = success['response']['clinic']['paths']['{}'];
            this.listDoctor = this.creatValuesDoctor(success['response']['staff']['paths']['{}']);
            const optionsClinic: any[] = [];
            const optionsDoctor: any[] = [];
            this.listClinic.forEach(el => {
                el['title'] = el['name'];
                optionsClinic.push(el);
            });
            const findClinic = this.arrSearchDefault.findIndex(el => {
                return el['propertyName'] == 'clinic';
            });
            if (findClinic != -1) {
                const clinic = this.arrSearchDefault[findClinic];
                clinic['schema']['options'] = optionsClinic;
                this.arrSearchDefault[findClinic] = clinic;
            }
            this.listDoctor.forEach(el => {
                el['title'] = el['fullName'];
                optionsDoctor.push(el);
            });
            const findDoctor = this.arrSearchDefault.findIndex(el => {
                return el['propertyName'] == 'doctor';
            });
            if (findDoctor != -1) {
                const doctor = this.arrSearchDefault[findDoctor];
                doctor['schema']['options'] = optionsDoctor;
                this.arrSearchDefault[findDoctor] = doctor;
            }

            this.pageSize = 30;
            // this.tmpDataSearchResponse = success['response']['client'] && success['response']['client']['searches'] && success['response']['client']['searches'][this.strkeySearch] ? success['response']['client']['searches'][this.strkeySearch] : [];
            // this.dataSearchResponse = this.tmpDataSearchResponse.slice(0, this.pageSize);
            // // this.dataSearchResponse = success['response']['client']['searches'][result];
            // this.dataSearchResponseCount = this.tmpDataSearchResponse.length
            this.sumarySearchText()
            $('.ng-scrollbar').removeClass('-vertical')
        }
    }

    functionEmitDataSearch = (dataSearch: any) => {
        this.refreshToken();
        this.searchData.next(dataSearch);
    }

    searchLastSend(time: number) {
        let lte = moment(time).endOf('day').utc().valueOf()
        let gte = moment(lte).subtract(2, 'days').startOf('day').utc().valueOf()
        return {
            $gte: gte,
            $lte: lte,
        }
    }

    searchChatSend(time: number) {
        let lte = moment(time).endOf('day').utc().valueOf()
        let gte = moment(lte).startOf('day').utc().valueOf()
        console.log(lte, gte)
        return {
            $gte: gte,
            $lte: lte,
        }
    }

    getMatrix(arr: any[] = []) {
        this.arrImage = []
        this.matrixImage = []
        arr.forEach((el, i) => {
            if (el != undefined && el['faceImage'] != undefined && el['faceImage']['id']) {
                const url: any = this.baseImageUrl + el['faceImage']['id'] + '?type=small'
                this.arrImage.push(url)
            } else {
                this.arrImage.push(undefined)
            }
            if (el != undefined && el['faceImage'] != undefined && el['faceImage']['matrix'] != undefined) {
                const matrix: any = el['faceImage']['matrix']
                this.matrixImage.push(matrix)
            } else {
                const matrix: any = [1, 0, 0, 1]
                this.matrixImage.push(matrix)
            }
            if (el != undefined && el['faceImage'] != undefined && el['faceImage']['style'] != undefined) {
                const style: any = el['faceImage']['style']
                this.styleImage.push(style)
            }else {
                this.styleImage.push(null)
            }
        })
    }

    isBirthMonth(client) {
        if (client && client.birthday) {
            const birthday = (moment(client.birthday).toDate())
            return birthday.getMonth() == (new Date()).getMonth()
        }
        return false
    }

    changeSource(event, indexp) {
        event.target.src = ''
        this.dataSearchResponse[indexp].faceImage = undefined
    }

    onScroll() {
        if((this.dataSearchResponseCount <= (this.offset + this.limit)) || this.tableShowDataSearch == 'hidden'){
            return;
        }
        this.refreshToken();
        this.offset += this.limit;
        if(this.initScroll){
            this.getDatasearch();
        }else{
            const resourceDataAccessLog = this.searchScroll(this.currentCondition);
            // console.log("res: " + JSON.stringify(resourceDataAccessLog));
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, this.tokenReNew).subscribe(response => {
                this.onSearchDone(response);
            });
        }
        for (let i = this.offset; i < this.dataSearchResponse.length; i++) {
            if (this.dataSearchResponse[i] != undefined && this.dataSearchResponse[i]['faceImage'] != undefined && this.dataSearchResponse[i]['faceImage']['id'] ) {
                const url: any = this.baseImageUrl + this.dataSearchResponse[i]['faceImage']['id'] + '?type=small';
                this.arrImage.push(url);
            } else {
                this.arrImage.push(undefined);
            }
            if (this.dataSearchResponse[i] != undefined && this.dataSearchResponse[i]['faceImage'] != undefined && this.dataSearchResponse[i]['faceImage']['matrix'] != undefined) {
                const matrix: any = this.dataSearchResponse[i]['faceImage']['matrix'];
                this.matrixImage.push(matrix);
            } else {
                const matrix: any = [1, 0, 0, 1];
                this.matrixImage.push(matrix);
            }
            if (this.dataSearchResponse[i] != undefined && this.dataSearchResponse[i]['faceImage'] != undefined && this.dataSearchResponse[i]['faceImage']['style'] != undefined) {
                const style: any = this.dataSearchResponse[i]['faceImage']['style'];
                this.styleImage.push(style);
            } else {
                this.styleImage.push(null);
            }
        }
        $('.ng-scrollbar').removeClass('-vertical');
    }

    onScrollOld() {
        const start: any = this.pageSize;
        this.pageSize += this.addPageSize;
        // this.dataSearchResponse = this.tmpDataSearchResponse.slice(0, this.pageSize);
        for (let i = start; i < this.pageSize; i++) {
            if (this.dataSearchResponse[i] != undefined && this.dataSearchResponse[i]['faceImage'] != undefined && this.dataSearchResponse[i]['faceImage']['id'] ) {
                const url: any = this.baseImageUrl + this.dataSearchResponse[i]['faceImage']['id'] + '?type=small'
                this.arrImage.push(url)
            } else {
                this.arrImage.push(undefined)
            }
            if (this.dataSearchResponse[i] != undefined && this.dataSearchResponse[i]['faceImage'] != undefined && this.dataSearchResponse[i]['faceImage']['matrix'] != undefined) {
                const matrix: any = this.dataSearchResponse[i]['faceImage']['matrix']
                this.matrixImage.push(matrix)
            } else {
                const matrix: any = [1, 0, 0, 1]
                this.matrixImage.push(matrix)
            }
        }
        $('.ng-scrollbar').removeClass('-vertical')
    }

    sumarySearchText() {
        if (this.dataSearchResponseCount > 0) {
            this.getMatrix(this.dataSearchResponse)
            if (this._sharedService.arrayKeySearchValuesChangeForUser) {
                if (this.tableShowDataSearch == 'active') {
                    this.resultNotification = this.defaultToogleText
                    this.showTableData = true
                } else {
                    this.resultNotification = 'Result contains ' + this.dataSearchResponseCount + ' items.Limit search condition, or toggle switch to show all items.'
                    this.showTableData = false
                }
            } else {
                if (this.tableShowDataSearch == 'active') {
                    this.resultNotification = this.defaultToogleText
                    this.showTableData = true
                } else {
                    this.resultNotification = 'Result contains ' + this.dataSearchResponseCount + ' items.Limit search condition, or toggle switch to show all items.'
                    this.showTableData = false
                }
            }
        } else {
            this.resultNotification = 'Result contains no items.'
        }
    }

    activeHotKey(isActive: boolean) {
        this.isActiveHotKey = isActive
    }

    private getCachedSearchDataIfExist() {
        const cachedSearchData = this.stateServices.getSearchTabIdsByPageNameUse(this.pageName)
        if (cachedSearchData) {
            if (cachedSearchData.arrIdClickedTabs) {
                this.arrIdClickedTabs = cachedSearchData.arrIdClickedTabs
            }

            if (cachedSearchData.arrayAlignerTabs) {
                this.arrayAlignerTabs = cachedSearchData.arrayAlignerTabs
            }

            if (cachedSearchData.jsonDataSearch) {
                this.jsonDataSearch = cachedSearchData.jsonDataSearch
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client/select-client/select-client.component.ts